export const uiMessagesNl = {
  "Loading chat...": "Chat wordt geladen...",
  "Error": "Fout",
  "Try again": "Opnieuw proberen",
  "Go home": "Naar home",
  "Error details": "Foutdetails",
  "Loading escort panel...": "Escortpaneel wordt geladen...",
  "Something went wrong!": "Er is iets misgegaan.",
  "Signing you in…": "Je wordt ingelogd…",
  "Completing secure handoff.": "Beveiligde overdracht wordt afgerond.",
  "Go to login": "Naar inloggen",
  "Loading...": "Laden...",
  "Sign in to live chat": "Inloggen bij live chat",
  "Continue to your chat, live, or operator workspace.": "Ga verder naar je chat-, live- of operatorwerkruimte.",
  "Email address": "E-mailadres",
  "Password": "Wachtwoord",
  "Use the same account you use on the tenant website.": "Gebruik hetzelfde account als op de website.",
  "Signing you out…": "Je wordt uitgelogd…",
  "Clearing your session.": "Je sessie wordt gewist.",
  "Redirecting…": "Je wordt doorgestuurd…",
  "Page Not Found": "Pagina niet gevonden",
  "The page you’re looking for doesn’t exist.": "De pagina die je zoekt bestaat niet.",
  "Go Home": "Naar home",
  "Live chat": "Live chat",
  "Routing you to the right workspace for your account.": "Je wordt naar de juiste werkruimte voor je account gestuurd.",
  "Attachment preview": "Voorbeeld van bijlage",
  "Close attachment preview": "Voorbeeld van bijlage sluiten",
  "Open original": "Origineel openen",
  "Close": "Sluiten",
  "Previous attachment": "Vorige bijlage",
  "Next attachment": "Volgende bijlage",
  "Attachment": "Bijlage",
  "Open attachment": "Bijlage openen",
  "Photo": "Foto",
  "Video": "Video",
  "Camera": "Camera",
  "Location": "Locatie",
  "Coming soon": "Binnenkort",
  "Document": "Document",
  "Add attachment": "Bijlage toevoegen",
  "Close attachment menu": "Bijlagenmenu sluiten",
  "Photos up to": "Foto’s tot",
  ", videos up to": ", video’s tot",
  "File": "Bestand",
  "Connection error:": "Verbindingsfout:",
  "Welcome to Messages": "Welkom bij Berichten",
  "View Conversations": "Gesprekken bekijken",
  "Chats": "Chats",
  "Discover": "Ontdekken",
  "Sidebar sections": "Onderdelen van zijbalk",
  "Discover more profiles online now": "Ontdek meer profielen die nu online zijn",
  "No Conversation Selected": "Geen gesprek geselecteerd",
  "Choose a conversation from the list to start chatting": "Kies een gesprek uit de lijst om te chatten",
  "Start a voice call": "Spraakoproep starten",
  "Start a video call": "Video-oproep starten",
  "free left": "gratis over",
  "Free chat": "Gratis chat",
  "✓ Paid": "✓ Betaald",
  "Approval needed": "Goedkeuring nodig",
  "View my profile": "Mijn profiel bekijken",
  "number": "nummer",
  "Reconnecting…": "Opnieuw verbinden…",
  "Disconnected. Messages cannot be sent right now.": "Verbinding verbroken. Berichten kunnen nu niet worden verzonden.",
  "Finish your current call first": "Beëindig eerst je huidige oproep",
  "⤤ Full screen": "⤤ Volledig scherm",
  "End this session for both of you": "Deze sessie voor jullie beiden beëindigen",
  "Balance empty.": "Saldo is op.",
  "Top up to continue chatting.": "Waardeer op om verder te chatten.",
  "Low balance.": "Laag saldo.",
  "Top up": "Opwaarderen",
  "Waiting for approval.": "Wachten op goedkeuring.",
  "Free messages are used up. Approve to continue": "De gratis berichten zijn op. Keur goed om door te gaan",
  "Approve": "Goedkeuren",
  "Start the conversation": "Gesprek starten",
  "Send your first message to": "Stuur je eerste bericht naar",
  "Enter": "Enter",
  "send": "verzenden",
  "Shift+Enter": "Shift+Enter",
  "newline": "nieuwe regel",
  "min remaining": "minuten resterend",
  "Loading conversations...": "Gesprekken worden geladen...",
  "New Conversation": "Nieuw gesprek",
  "No messages yet": "Nog geen berichten",
  "🎙 Voice": "🎙 Spraak",
  "📹 Video": "📹 Video",
  "Waiting for approval": "Wachten op goedkeuring",
  "Paid chat": "Betaalde chat",
  "conversations with": "gesprekken met",
  "More": "Meer",
  "More actions": "Meer acties",
  "Report user": "Gebruiker melden",
  "Logout": "Uitloggen",
  "Payment Methods": "Betaalmethoden",
  "Pick a package. Bonus on €100 and up.": "Kies een pakket. Bonus vanaf € 100.",
  "No top-up packages available right now.": "Er zijn nu geen opwaardeerpakketten beschikbaar.",
  "Adds": "Voegt toe",
  "balance": "saldo",
  "Custom amounts coming soon": "Aangepaste bedragen binnenkort beschikbaar",
  "Pay:": "Betalen:",
  "Adds:": "Toegevoegd:",
  "Choose how you want to pay.": "Kies hoe je wilt betalen.",
  "No payment methods are configured for this site.": "Er zijn geen betaalmethoden ingesteld voor deze website.",
  "Checkout opened in a new tab": "Betaalpagina geopend in een nieuw tabblad",
  "Finish your payment in the other tab. Your balance updates here automatically when you come back. You can safely close this.": "Voltooi je betaling in het andere tabblad. Je saldo wordt hier automatisch bijgewerkt wanneer je terugkomt. Je kunt dit veilig sluiten.",
  "Done": "Klaar",
  "Close top-up sheet": "Opwaardeerscherm sluiten",
  "Back to package picker": "Terug naar pakketkeuze",
  "Incognito Blur": "Incognitovervaging",
  "Soft Blur": "Lichte vervaging",
  "Full Camera": "Volledig camerabeeld",
  "Voice Only": "Alleen spraak",
  "Start a private session": "Privésessie starten",
  "Voice calls not available": "Spraakoproepen niet beschikbaar",
  "Video calls not available": "Video-oproepen niet beschikbaar",
  "billing starts when accepted": "betaling start na acceptatie",
  "Choose your camera mode": "Kies je cameramodus",
  "← Back": "← Terug",
  "All live camera modes are currently disabled in your availability settings. Decline this request or update your preferences first.": "Alle live-cameramodi zijn uitgeschakeld in je beschikbaarheidsinstellingen. Wijs dit verzoek af of werk eerst je voorkeuren bij.",
  "Customer can use:": "Klant kan gebruiken:",
  "🎙 Mic": "🎙 Microfoon",
  "📹 Camera": "📹 Camera",
  "★ default": "★ standaard",
  "requested": "aangevraagd",
  "Cancel live session request": "Verzoek voor live-sessie annuleren",
  "Waiting for a response": "Wachten op antwoord",
  "Balance empty": "Saldo is op",
  "top up to call again.": "waardeer op om opnieuw te bellen.",
  "Not available right now": "Nu niet beschikbaar",
  "No response - send a new request": "Geen antwoord, stuur een nieuw verzoek",
  "Sending": "Wordt verzonden",
  "Sent": "Verzonden",
  "Failed to send. Tap to retry.": "Verzenden mislukt. Tik om opnieuw te proberen.",
  "Failed to send": "Verzenden mislukt",
  "Delete": "Verwijderen",
  "Delete for the customer": "Verwijderen voor de klant",
  "Delete this message for the customer? Operators will still see it, marked as deleted.": "Dit bericht verwijderen voor de klant? Operators zien het nog wel, gemarkeerd als verwijderd.",
  "Deleted: the customer no longer sees this message": "Verwijderd: de klant ziet dit bericht niet meer",
  "Could not delete the message.": "Het bericht kon niet worden verwijderd.",
  "Start a new conversation": "Nieuw gesprek starten",
  "Search profiles by name or city…": "Zoek profielen op naam of stad…",
  "Message a customer": "Klant een bericht sturen",
  "Search customers by name…": "Zoek klanten op naam…",
  "free": "gratis",
  "Select a profile to start a conversation": "Selecteer een profiel om een gesprek te starten",
  "Creating conversation…": "Gesprek wordt gemaakt…",
  "Paid conversation": "Betaald gesprek",
  "Your approval is required to continue": "Je goedkeuring is nodig om door te gaan",
  "This conversation has been switched to": "Dit gesprek is omgeschakeld naar",
  "paid mode": "betaalde modus",
  ". Each message you send will be charged to your account.": ". Voor elk bericht dat je verstuurt worden kosten van je account afgeschreven.",
  "Price per message:": "Prijs per bericht:",
  "Credits are deducted from your wallet balance.": "Credits worden van je walletsaldo afgeschreven.",
  "Cancel": "Annuleren",
  "Show all conversations": "Alle gesprekken tonen",
  "Select at least one message or attachment.": "Selecteer minimaal één bericht of bijlage.",
  "Close report dialog": "Meldingsvenster sluiten",
  "Report": "Melden",
  "What are you reporting?": "Wat wil je melden?",
  "Only content you select here will be shared with the safety team.": "Alleen de content die je hier selecteert wordt met het veiligheidsteam gedeeld.",
  "No messages are available to select.": "Er zijn geen berichten om te selecteren.",
  "Reason": "Reden",
  "Additional details (optional)": "Aanvullende details (optioneel)",
  "Balance": "Saldo",
  "Top up balance": "Saldo opwaarderen",
  "Verified profile": "Geverifieerd profiel",
  "from": "vanaf",
  "No chat actor available for this listing": "Geen chatcontact beschikbaar voor deze advertentie",
  "Chat unavailable": "Chat niet beschikbaar",
  "Online": "Online",
  "Nearby": "In de buurt",
  "All": "Alles",
  "Show list view": "Lijstweergave tonen",
  "Show map view": "Kaartweergave tonen",
  "No profiles to show": "Geen profielen om te tonen",
  "Try a different filter or check back later.": "Probeer een ander filter of kijk later opnieuw.",
  "Available now": "Nu beschikbaar",
  "Service areas": "Servicegebieden",
  "Discover map": "Ontdekkingskaart",
  "Discover · Map": "Ontdekken · Kaart",
  "Close map": "Kaart sluiten",
  "Search this area": "Zoek in dit gebied",
  "Updating": "Wordt bijgewerkt",
  "Open your payouts page on the main site": "Open je uitbetalingspagina op de hoofdwebsite",
  "Withdraw earnings (opens your payouts page)": "Inkomsten opnemen (opent je uitbetalingspagina)",
  "Withdraw": "Opnemen",
  "Withdrawals are managed on your main site account page.": "Opnames worden beheerd op de accountpagina van de hoofdwebsite.",
  "Withdraw earnings (unavailable)": "Inkomsten opnemen (niet beschikbaar)",
  "Geolocation is not available in this browser.": "Geolocatie is niet beschikbaar in deze browser.",
  "No known city found near your position.": "Er is geen bekende stad in de buurt van je positie gevonden.",
  "Could not resolve your position to a city.": "Je positie kon niet aan een stad worden gekoppeld.",
  "Location permission denied - search for your city instead.": "Locatietoestemming geweigerd. Zoek in plaats daarvan je stad.",
  "Close location editor": "Locatiebewerker sluiten",
  "or": "of",
  "Find a city…": "Zoek een stad…",
  "Find a city for the current location": "Zoek een stad voor de huidige locatie",
  "Visible": "Zichtbaar",
  "Radius": "Straal",
  "km": "km",
  "Notifications": "Meldingen",
  "Mark all read": "Alles als gelezen markeren",
  "No notifications yet": "Nog geen meldingen",
  "Claimed": "Geclaimd",
  "Close reel recorder": "Reel-opname sluiten",
  "s /": "s /",
  "Starting camera…": "Camera wordt gestart…",
  "Publishing your reel…": "Je reel wordt gepubliceerd…",
  "Reel published!": "Reel gepubliceerd!",
  "It will appear in the reels feed for customers in your area shortly.": "De reel verschijnt binnenkort in de feed voor klanten in jouw omgeving.",
  "Retry upload": "Upload opnieuw proberen",
  "Start recording (": "Opname starten (",
  "s)": "s)",
  "The frame shows exactly what customers will see.": "Het kader toont precies wat klanten zullen zien.",
  "Recording stops automatically…": "De opname stopt automatisch…",
  "Discard": "Verwijderen",
  "Retake": "Opnieuw opnemen",
  "Publish": "Publiceren",
  "No conversation selected": "Geen gesprek geselecteerd",
  "Choose a conversation from the list": "Kies een gesprek uit de lijst",
  "End session": "Sessie beëindigen",
  "Connecting": "Verbinden",
  "Connected": "Verbonden",
  "Disconnected": "Verbinding verbroken",
  "● In session": "● In sessie",
  "In call": "In gesprek",
  "Return to call": "Terug naar gesprek",
  "Disconnected - messages cannot be sent.": "Verbinding verbroken. Berichten kunnen niet worden verzonden.",
  "Finish your current call before accepting a new one.": "Beëindig je huidige gesprek voordat je een nieuw gesprek accepteert.",
  "In session": "In sessie",
  "⤢ Full screen": "⤢ Volledig scherm",
  "In room:": "In room:",
  "You": "Jij",
  "Customer": "Klant",
  "No messages yet - say hello!": "Nog geen berichten. Zeg hallo!",
  "Sent by your operator": "Verzonden door je operator",
  "Sent automatically as a chat invitation": "Automatisch verstuurd als chatuitnodiging",
  "is typing…": "is aan het typen…",
  "Text chat always available": "Tekstchat altijd beschikbaar",
  "📹 Live request": "📹 Live-verzoek",
  "🎙 Audio request": "🎙 Audioverzoek",
  "🔴 Live session": "🔴 Live-sessie",
  "🔴 Audio session": "🔴 Audiosessie",
  "Declined": "Afgewezen",
  "Expired": "Verlopen",
  "■ Ended": "■ Beëindigd",
  "Loading…": "Laden…",
  "Adjust availability": "Beschikbaarheid aanpassen",
  "Customer is typing": "Klant is aan het typen",
  "typing…": "aan het typen…",
  "No followers yet": "Nog geen volgers",
  "Share your profile and chat with new customers to grow your fanbase.": "Deel je profiel en chat met nieuwe klanten om meer volgers te krijgen.",
  "People who liked your profile.": "Mensen die je profiel leuk vinden.",
  "Create a reel": "Reel maken",
  "Location updated": "Locatie bijgewerkt",
  "Not set - customers can’t see you nearby": "Niet ingesteld. Klanten kunnen je niet in de buurt zien",
  "Update your location": "Je locatie bijwerken",
  "No one online right now": "Er is nu niemand online",
  "Customers will appear here as soon as they open the app.": "Klanten verschijnen hier zodra ze de app openen.",
  "This user follows you": "Deze gebruiker volgt je",
  "Follows you": "Volgt je",
  "Unavailable": "Niet beschikbaar",
  "Availability": "Beschikbaarheid",
  "Loading preferences…": "Voorkeuren worden geladen…",
  "Customer publish defaults": "Standaarden voor klantenweergave",
  "These are pre-filled when accepting; you can override per session.": "Deze waarden worden vooraf ingevuld bij acceptatie. Je kunt ze per sessie aanpassen.",
  "Allowed camera modes": "Toegestane cameramodi",
  "Enable at least one camera mode to accept live sessions.": "Schakel minimaal één cameramodus in om live-sessies te accepteren.",
  "Default accept mode": "Standaard acceptatiemodus",
  "Ask every time": "Elke keer vragen",
  "Video requests are accepted in this mode with one tap - no chooser.": "Videoverzoeken worden in deze modus met één tik geaccepteerd, zonder extra keuze.",
  "Saved": "Opgeslagen",
  "Followers": "Volgers",
  "more": "meer",
  "Room not connected": "Room niet verbonden",
  "Customers can": "Klanten kunnen",
  "t see you yet - start your camera below": "je nog niet zien. Start hieronder je camera",
  "live": "live",
  "live (fallback)": "live (fallback)",
  "Lighter blur - the customer sees a bit more of you": "Lichte vervaging. De klant ziet iets meer van je",
  "Heavy blur - face not identifiable": "Sterke vervaging. Je gezicht is niet herkenbaar",
  "Are you sure? Once revealed the customer can see your face.": "Weet je het zeker? Na het onthullen kan de klant je gezicht zien.",
  "Yes, reveal my face": "Ja, toon mijn gezicht",
  "Showing solid placeholder - your camera is NOT transmitted.": "Een effen tijdelijke afbeelding wordt getoond. Je camerabeeld wordt NIET verzonden.",
  "Publishing unfiltered camera (filter unavailable in this browser).": "Ongefilterd camerabeeld wordt verzonden omdat het filter niet beschikbaar is in deze browser.",
  "30 min": "30 min",
  "1 hour": "1 uur",
  "3 hours": "3 uur",
  "Until tomorrow": "Tot morgen",
  "/min": "/min",
  "Incoming request": "Inkomend verzoek",
  "tap to open the chat": "tik om de chat te openen",
  "Choose a different camera mode": "Andere cameramodus kiezen",
  "More decline options": "Meer opties om af te wijzen",
  "Mute calls from this customer": "Oproepen van deze klant dempen",
  "Block this customer": "Deze klant blokkeren",
  "s calls? You can resume them later.": "oproepen blokkeren? Je kunt ze later hervatten.",
  "Block": "Blokkeren",
  "Could not join session": "Kon niet deelnemen aan de sessie",
  "Pop out video (picture-in-picture)": "Video losmaken (beeld-in-beeld)",
  "Pop out video": "Video losmaken",
  "Minimize (Esc)": "Minimaliseren (Esc)",
  "Minimize call": "Gesprek minimaliseren",
  "Back to full screen": "Terug naar volledig scherm",
  "Expand call": "Gesprek vergroten",
  "Tap to speak": "Tik om te spreken",
  "Tap again to end": "Tik opnieuw om te beëindigen",
  "Unable to join call": "Deelnemen aan gesprek mislukt",
  "Please try again or check your connection.": "Probeer het opnieuw of controleer je verbinding.",
  "Tap to enable sound": "Tik om geluid in te schakelen",
  "🎙️ Audio Only": "🎙️ Alleen audio",
  "🎙 Live - Voice Only": "🎙 Live, alleen spraak",
  "📹 Live - Full Camera": "📹 Live, volledig camerabeeld",
  "🕶️ Live - Incognito Blur": "🕶️ Live, incognitovervaging",
  "🌫️ Live - Soft Blur": "🌫️ Live, lichte vervaging",
  "Excellent": "Uitstekend",
  "Good": "Goed",
  "Poor": "Slecht",
  "Lost": "Verbroken",
  "with": "met",
  "This escort is currently in Privacy Mode.": "Deze escort gebruikt momenteel de privacymodus.",
  "Get to know each other first. She decides when to reveal herself.": "Leer elkaar eerst kennen. Zij bepaalt wanneer ze zichzelf laat zien.",
  "Privacy Mode": "Privacymodus",
  "Reset to free chat": "Terugzetten naar gratis chat",
  "Set free": "Gratis instellen",
  "Set paid": "Betaald instellen",
  "Select a conversation from the Conversations panel to start chatting": "Selecteer een gesprek in het paneel Gesprekken om te chatten",
  "Currently acting as": "Handelt momenteel als",
  "Customer is online now": "Klant is nu online",
  "online": "online",
  "Conversation with": "Gesprek met",
  "Claimed by": "Geclaimd door",
  ". You can read but cannot reply while this claim is active.": ". Je kunt lezen maar niet antwoorden zolang deze claim actief is.",
  "Paid chat: customer is charged per message.": "Betaalde chat: de klant betaalt per bericht.",
  "Waiting for customer approval. Customer cannot send yet.": "Wachten op goedkeuring van de klant. De klant kan nog niet verzenden.",
  "Search profiles and conversations…": "Zoek profielen en gesprekken…",
  "Esc": "Esc",
  "Profile · open conversations": "Profiel · open gesprekken",
  "↑↓ navigate": "↑↓ navigeren",
  "Enter open": "Enter openen",
  "Esc close": "Esc sluiten",
  "Customers": "Klanten",
  "Open the map - customers & performers": "Kaart openen, klanten en performers",
  "Open map": "Kaart openen",
  "Mine": "Van mij",
  "Queue": "Wachtrij",
  "Select a profile from the roster to view conversations": "Selecteer een profiel uit het rooster om gesprekken te bekijken",
  "Hot lead": "Warme lead",
  "⚠️ waiting": "⚠️ wacht",
  "Unclaimed": "Niet geclaimd",
  "Claimed by me ·": "Door mij geclaimd ·",
  "Release claim": "Claim vrijgeven",
  "free messages left": "gratis berichten over",
  "Active": "Actief",
  "Refresh conversations": "Gesprekken vernieuwen",
  "Operator notes": "Operatornotities",
  "Shared with all operators - survives claim handovers. Never visible to the customer.": "Gedeeld met alle operators en behouden bij overdracht van claims. Nooit zichtbaar voor de klant.",
  "Loading notes…": "Notities worden geladen…",
  "No notes yet.": "Nog geen notities.",
  "Add a note for the next operator…": "Voeg een notitie toe voor de volgende operator…",
  "Customer context": "Klantcontext",
  "· returning today": "· vandaag terug",
  "Hot lead:": "Warme lead:",
  "customer is online, has used all free messages and nobody has claimed this conversation. Reply now to convert.": "de klant is online, heeft alle gratis berichten gebruikt en niemand heeft dit gesprek geclaimd. Antwoord nu om te converteren.",
  "Customer value": "Klantwaarde",
  "Chat state": "Chatstatus",
  "Claim": "Claimen",
  "Unclaimed. Replying claims it for you.": "Niet geclaimd. Door te antwoorden claim je het gesprek.",
  "Claimed by you": "Door jou geclaimd",
  ". Sending is blocked until it expires.": ". Verzenden is geblokkeerd totdat de claim verloopt.",
  "Activity": "Activiteit",
  "New": "Nieuw",
  "Returning": "Terugkerend",
  "Paid": "Betaald",
  "Chatted": "Gechat",
  "Recent": "Recent",
  "Sort nearby first": "Dichtstbij eerst sorteren",
  "Could not load customers.": "Klanten konden niet worden geladen.",
  "NEW": "NIEUW",
  "Open conversation": "Gesprek openen",
  "Greet customer": "Klant begroeten",
  "Refresh customers": "Klanten vernieuwen",
  "No active session": "Geen actieve sessie",
  "Acting as": "Handelt als",
  "Stop masquerade session": "Masqueradesessie stoppen",
  "Stop": "Stoppen",
  "Session Expiry": "Sessie verloopt",
  "Security Notice": "Beveiligingsmelding",
  "This token allows you to act as": "Met dit token kun je handelen als",
  ". Keep it secure and never share it with others.": ". Bewaar het veilig en deel het nooit met anderen.",
  "Stop Session": "Sessie stoppen",
  "Snippets": "Snippets",
  "↑↓ navigate · Enter insert · Esc dismiss": "↑↓ navigeren · Enter invoegen · Esc sluiten",
  "/trigger - random opener": "/trigger - willekeurige opener",
  "Insert a random trigger for": "Voeg een willekeurige trigger in voor",
  "(editable before send)": "(bewerkbaar voor verzenden)",
  "Loading snippets…": "Snippets worden geladen…",
  "Send blocked:": "Verzenden geblokkeerd:",
  "conversation claimed by": "gesprek geclaimd door",
  "(expires in": "(verloopt over",
  ". Wait for the claim to expire or be released.": ". Wacht tot de claim verloopt of wordt vrijgegeven.",
  "profile session held by": "profielsessie in gebruik door",
  ". Wait for the session to end or be released.": ". Wacht tot de sessie eindigt of wordt vrijgegeven.",
  "Session unavailable - held by another operator": "Sessie niet beschikbaar - in gebruik door een andere operator",
  "Send blocked: session held by another operator": "Verzenden geblokkeerd: sessie in gebruik door een andere operator",
  "Switching session to": "Sessie wordt omgeschakeld naar",
  "No active session. Replies are sent as": "Geen actieve sessie. Antwoorden worden verzonden als",
  "Active session is for": "Actieve sessie is voor",
  "but this conversation belongs to": "maar dit gesprek hoort bij",
  "Session active:": "Sessie actief:",
  "Insert a random trigger (click again to reroll)": "Willekeurige trigger invoegen (klik opnieuw voor een andere)",
  "Insert random trigger": "Willekeurige trigger invoegen",
  "Enter to send · Shift+Enter for new line · / for snippets": "Enter om te verzenden · Shift+Enter voor nieuwe regel · / voor snippets",
  "Loading messages...": "Berichten worden geladen...",
  "Start the conversation!": "Start het gesprek!",
  "(via operator)": "(via operator)",
  "Jump to the next unanswered conversation": "Ga naar het volgende onbeantwoorde gesprek",
  "Chat messages": "Chatberichten",
  "Today": "Vandaag",
  "This week": "Deze week",
  "This month": "Deze maand",
  "Last month": "Vorige maand",
  "vs last month": "ten opzichte van vorige maand",
  "Your earnings": "Je inkomsten",
  "Refresh earnings": "Inkomsten vernieuwen",
  "You can withdraw": "Je kunt laten uitbetalen",
  "Earned this month": "Deze maand verdiend",
  "Not available yet": "Nog niet beschikbaar",
  "Via your office this month": "Via je office deze maand",
  "Request payout": "Uitbetaling aanvragen",
  "Open my earnings": "Open mijn verdiensten",
  "How payouts work": "Zo werken uitbetalingen",
  "Payouts are requested from your earnings page on the main site.": "Uitbetalingen vraag je aan via je verdienstenpagina op de hoofdsite.",
  "Performance": "Prestaties",
  "Earnings become available": "Inkomsten worden beschikbaar",
  "days after they are earned. Payouts are handled from your account on the main site.": "dagen nadat ze zijn verdiend. Uitbetalingen beheer je via je account op de hoofdwebsite.",
  "Connecting...": "Verbinden...",
  "Operator Console": "Operatorconsole",
  "Please log in to access the operator console.": "Log in om de operatorconsole te openen.",
  "Welcome back,": "Welkom terug,",
  "Jump to the next unanswered conversation (Alt+N)": "Ga naar het volgende onbeantwoorde gesprek (Alt+N)",
  "Next up": "Volgende",
  "Search profiles and conversations (Ctrl/⌘+K)": "Zoek profielen en gesprekken (Ctrl/⌘+K)",
  "Operator settings": "Operatorinstellingen",
  "Auto-switch session": "Sessie automatisch omschakelen",
  "When opening a conversation for a different profile, automatically stop the current session and start one for that profile.": "Stop bij het openen van een gesprek voor een ander profiel automatisch de huidige sessie en start een sessie voor dat profiel.",
  "Profiles": "Profielen",
  "Conversations": "Gesprekken",
  "Chat": "Chat",
  "Assigned Profiles": "Toegewezen profielen",
  "Assigned team members": "Toegewezen teamleden",
  "Active chats": "Actieve chats",
  "pts": "pt",
  "(you)": "(jij)",
  "msgs": "berichten",
  "customers": "klanten",
  "avg reply": "gem. antwoord",
  "Weekly operator toplist": "Wekelijkse operatorranglijst",
  "Weekly toplist": "Wekelijkse ranglijst",
  "updates in": "wordt bijgewerkt over",
  "Refresh": "Vernieuwen",
  "No ranked operators this week yet.": "Deze week staan er nog geen operators in de ranglijst.",
  "Rank by sending": "Kom in de ranglijst door",
  "+ messages to": "+ berichten te sturen naar",
  "+ customers.": "+ klanten.",
  "Your position": "Jouw positie",
  "Ranked": "In ranglijst",
  "Not ranked yet": "Nog niet in ranglijst",
  "How to climb:": "Zo stijg je:",
  "quality beats volume. Fast first replies, conversations that convert (top-ups, paid chats) and reaching more unique customers score higher than raw message count.": "kwaliteit weegt zwaarder dan volume. Snelle eerste antwoorden, gesprekken die converteren (opwaarderingen en betaalde chats) en meer unieke klanten bereiken scoren hoger dan alleen veel berichten.",
  "Current location": "Huidige locatie",
  "Not set - profile is invisible in “near you”": "Niet ingesteld. Het profiel is niet zichtbaar bij ‘in de buurt’.",
  "Update this profile's location": "Locatie van dit profiel bijwerken",
  "Performer context": "Performercontext",
  "View profile": "Profiel bekijken",
  "Service area:": "Werkgebied:",
  "Current location:": "Huidige locatie:",
  "No service area set": "Geen werkgebied ingesteld",
  "Open the public profile in a new tab": "Open het openbare profiel in een nieuw tabblad",
  "ID verified": "ID geverifieerd",
  "Your active session sends replies as this profile.": "Je actieve sessie verstuurt antwoorden als dit profiel.",
  "Loading profile…": "Profiel wordt geladen…",
  "Could not load the profile.": "Het profiel kon niet worden geladen.",
  "Retry": "Opnieuw proberen",
  "No published profile on this tenant. Roster identity is shown above.": "Er is geen gepubliceerd profiel voor deze tenant. De roosteridentiteit staat hierboven.",
  "Photos": "Foto’s",
  "About": "Over",
  "Details": "Details",
  "Rates": "Tarieven",
  "more on the public profile": "meer op het openbare profiel",
  "Profile stats": "Profielstatistieken",
  "Favs": "Favorieten",
  "Follows": "Volgers",
  "Videos": "Video’s",
  "4 hours": "4 uur",
  "8 hours": "8 uur",
  "No profiles assigned": "Geen profielen toegewezen",
  "Show online for": "Online tonen voor",
  "online ·": "online ·",
  "online · until disabled": "online · tot uitschakeling",
  "chats": "chats",
  "Recent chats:": "Recente chats:",
  "Refresh roster": "Rooster vernieuwen",
  "🔥 VIP": "🔥 VIP",
  "High spender": "Grote besteder",
  "Regular": "Vaste klant",
  "Performers": "Performers",
  "Operations map": "Operationele kaart",
  "Refresh map data": "Kaartgegevens vernieuwen",
  "Could not load map data.": "Kaartgegevens konden niet worden geladen.",
  "No locations to show yet.": "Nog geen locaties om te tonen.",
  "Online now": "Nu online",
  "Nearest performer:": "Dichtstbijzijnde performer:",
  "(nearest)": "(dichtstbij)",
  "Approach as": "Benaderen als",
  "Choose the performer to approach this customer as": "Kies namens welke performer je deze klant benadert",
  "Open chat": "Chat openen",
  "Greet as :name": "Begroeten als :name",
  "Greet with active profile": "Begroeten met actief profiel",
  "Geolocation is not supported in this browser": "Geolocatie wordt niet ondersteund in deze browser",
  "Customers online": "Klanten online",
  "Waiting": "Wachtend",
  "Team online": "Team online",
  "Your revenue today": "Je omzet vandaag",
  "Your avg reply": "Je gem. antwoordtijd",
  "Top earner": "Topverdiener",
  "Fastest responder": "Snelste beantwoorder",
  "Customer magnet": "Klantmagneet",
  "Best €/message": "Beste €/bericht",
  "Idle": "Inactief",
  "Recently online": "Onlangs online",
  "Offline": "Offline",
  "Harassment": "Intimidatie",
  "Scam or fraud": "Oplichting of fraude",
  "Spam": "Spam",
  "Underage": "Minderjarig",
  "Fake photos": "Valse foto’s",
  "Other": "Anders",
  "Go Live": "Ga live",
  "Open Chat": "Chat openen",
  "Open Console": "Console openen",
  "Pick a package to continue.": "Kies een pakket om door te gaan.",
  "Pick a payment method to continue.": "Kies een betaalmethode om door te gaan.",
  "Top-up could not be started by the payment provider. Please try again.": "De betaalprovider kon de opwaardering niet starten. Probeer het opnieuw.",
  "No file selected": "Geen bestand geselecteerd",
  "No recording to upload": "Geen opname om te uploaden",
  "A customer sent a new message.": "Een klant heeft een nieuw bericht gestuurd.",
  "Customer just came online - a good moment to reach out.": "Een klant is zojuist online gekomen. Dit is een goed moment om contact op te nemen.",
  "Too many session switches. Wait a few seconds and try again.": "Te veel sessiewisselingen. Wacht een paar seconden en probeer het opnieuw.",
  "Reel recording starts in…": "Reel-opname begint in…",
  "This frame is exactly what customers will see.": "Dit kader is precies wat klanten straks zien.",
  "Uploading…": "Uploaden…",
  "REC": "REC",
  "Verify 21+ via VerifyPass for instant publishing.": "Verifieer 21+ via VerifyPass voor directe publicatie.",
  "Stop recording": "Opname stoppen",
  "Wait until :seconds s": "Wacht tot :seconds s",
  "Reel saved": "Reel opgeslagen",
  "Recording failed": "Opname mislukt",
  "Record reel": "Reel opnemen",
  "wait": "wacht",
  "Reel saved, visible after approval": "Reel opgeslagen, zichtbaar na goedkeuring",
  "expired": "verlopen",
  "No triggers for this profile yet - add some via the snippet library.": "Nog geen triggers voor dit profiel. Voeg ze toe via de snippetbibliotheek.",
  "this profile": "dit profiel",
  "No snippets yet - ask an admin to add them.": "Nog geen snippets. Vraag een beheerder om ze toe te voegen.",
  "No matching snippets.": "Geen overeenkomende snippets.",
  "another operator": "een andere operator",
  "the profile": "het profiel",
  "Starting...": "Wordt gestart...",
  "Start session for :name": "Sessie starten voor :name",
  "Switching...": "Wordt omgeschakeld...",
  "Switch session to :name": "Sessie omschakelen naar :name",
  "Select a conversation to start chatting...": "Selecteer een gesprek om te chatten...",
  "Sending blocked: conversation is claimed by another operator": "Verzenden geblokkeerd: het gesprek is geclaimd door een andere operator",
  "Switching session...": "Sessie wordt omgeschakeld...",
  "Start session for :name to send...": "Start een sessie voor :name om te verzenden...",
  "Switch session to :name to send...": "Schakel de sessie om naar :name om te verzenden...",
  "Type your message...": "Typ je bericht...",
  "Sending...": "Wordt verzonden...",
  "Send": "Verzenden",
  "Send blocked: claimed by another operator": "Verzenden geblokkeerd: geclaimd door een andere operator",
  "Send blocked: no active session": "Verzenden geblokkeerd: geen actieve sessie",
  "Send blocked: wrong profile session": "Verzenden geblokkeerd: sessie voor verkeerd profiel",
  "Could not send live invite": "Live-uitnodiging kon niet worden verzonden",
  "Conversation is claimed by another operator": "Het gesprek is geclaimd door een andere operator",
  "Invite the customer to a live session": "Nodig de klant uit voor een live-sessie",
  "Inviting…": "Uitnodiging wordt verzonden…",
  "Invited": "Uitgenodigd",
  "Failed": "Mislukt",
  "Invite to live": "Uitnodigen voor live",
  "Switch to paid chat - customer will need to approve": "Omschakelen naar betaalde chat - de klant moet dit goedkeuren",
  "Hide context panels": "Contextpanelen verbergen",
  "Show performer and customer context": "Performer- en klantcontext tonen",
  ", renews on every reply": ", wordt bij elk antwoord verlengd",
  "Accepting…": "Wordt geaccepteerd…",
  "Active Session": "Actieve sessie",
  "Add note": "Notitie toevoegen",
  "Add photo, video, or camera": "Foto, video of camera toevoegen",
  "Ahead of last month!": "Voor op vorige maand!",
  "An unexpected error occurred.": "Er is een onverwachte fout opgetreden.",
  "Another operator": "Een andere operator",
  "Approve paid mode to send messages…": "Keur de betaalde modus goed om berichten te verzenden…",
  "Back to conversations": "Terug naar gesprekken",
  "Block user": "Gebruiker blokkeren",
  "Blocking…": "Wordt geblokkeerd…",
  "Browser full screen": "Volledig scherm in browser",
  "Browser notifications blocked - enable in browser settings": "Browsermeldingen geblokkeerd - schakel ze in via de browserinstellingen",
  "Cancelling…": "Wordt geannuleerd…",
  "Catch them while they’re active.": "Neem contact op terwijl ze actief zijn.",
  "Choose payment method": "Betaalmethode kiezen",
  "Claim bonus": "Bonus claimen",
  "Claiming…": "Wordt geclaimd…",
  "Close conversation list": "Gesprekkenlijst sluiten",
  "Copied!": "Gekopieerd!",
  "Copy": "Kopiëren",
  "Customer is in room": "Klant is in de room",
  "Customer is not in room": "Klant is niet in de room",
  "Decline": "Afwijzen",
  "Declining…": "Wordt afgewezen…",
  "Delivered": "Afgeleverd",
  "Disable desktop notifications": "Bureaubladmeldingen uitschakelen",
  "Edit": "Bewerken",
  "Enable desktop notifications": "Bureaubladmeldingen inschakelen",
  "Ending…": "Wordt beëindigd…",
  "Escort": "Escort",
  "Exchanging token…": "Token wordt uitgewisseld…",
  "Exit browser full screen": "Volledig scherm in browser verlaten",
  "Exit full screen": "Volledig scherm verlaten",
  "Exit full screen (Esc)": "Volledig scherm verlaten (Esc)",
  "Failed to send - tap to retry": "Verzenden mislukt - tik om opnieuw te proberen",
  "Follower": "Volger",
  "Followers…": "Volgers…",
  "Free": "Gratis",
  "Getting the room ready…": "De room wordt klaargemaakt…",
  "Join now": "Nu deelnemen",
  "Joining…": "Deelnemen…",
  "Listing": "Advertentie",
  "Live": "Live",
  "Loading followers…": "Volgers worden geladen…",
  "Loading map…": "Kaart wordt geladen…",
  "Loading more…": "Meer laden…",
  "Loading online users…": "Online gebruikers worden geladen…",
  "Loading packages…": "Pakketten worden geladen…",
  "Loading payment methods…": "Betaalmethoden worden geladen…",
  "Locating…": "Locatie bepalen…",
  "Mark as read": "Als gelezen markeren",
  "Mark as unread": "Als ongelezen markeren",
  "Mute notification sounds": "Meldingsgeluiden dempen",
  "Mute notifications": "Meldingen dempen",
  "Nearby sort needs a located active profile": "Sorteren op afstand vereist een actief profiel met locatie",
  "Never": "Nooit",
  "No active claims. Send a reply to claim a conversation.": "Geen actieve claims. Stuur een antwoord om een gesprek te claimen.",
  "No conversations found": "Geen gesprekken gevonden",
  "No conversations yet": "Nog geen gesprekken",
  "No customers found.": "Geen klanten gevonden.",
  "No matches": "Geen resultaten",
  "No matching conversations": "Geen overeenkomende gesprekken",
  "No public details": "Geen openbare gegevens",
  "None": "Geen",
  "Online override active - click to disable": "Online-overschrijving actief - klik om uit te schakelen",
  "Online…": "Online…",
  "Open conversation list": "Gesprekkenlijst openen",
  "Operations · Map": "Operaties · Kaart",
  "Operator": "Operator",
  "Paid, active": "Betaald, actief",
  "Paid, waiting for customer approval": "Betaald, wacht op goedkeuring van de klant",
  "Payment started": "Betaling gestart",
  "Preview your reel": "Bekijk een voorbeeld van je reel",
  "Profile": "Profiel",
  "Profile photo": "Profielfoto",
  "Queue is empty. No unclaimed or active conversations.": "De wachtrij is leeg. Er zijn geen ongeclaimde of actieve gesprekken.",
  "Ready": "Gereed",
  "Resume calls": "Oproepen hervatten",
  "Resuming…": "Wordt hervat…",
  "Save": "Opslaan",
  "Saving…": "Wordt opgeslagen…",
  "Scroll to load more": "Scroll om meer te laden",
  "Select a conversation to start chatting": "Selecteer een gesprek om te chatten",
  "Select a profile from the roster first": "Selecteer eerst een profiel uit het rooster",
  "Sending…": "Wordt verzonden…",
  "Session active. Click to view token or stop.": "Sessie actief. Klik om het token te bekijken of te stoppen.",
  "Session in progress": "Sessie actief",
  "Set": "Instellen",
  "Show less": "Minder tonen",
  "Show more": "Meer tonen",
  "Show this profile as online": "Dit profiel als online tonen",
  "Sign in": "Inloggen",
  "Signing in…": "Bezig met inloggen…",
  "Someone": "Iemand",
  "Something went wrong. Please try again.": "Er is iets misgegaan. Probeer het opnieuw.",
  "Sort by distance to the active profile": "Sorteren op afstand tot het actieve profiel",
  "Start a conversation with the active profile": "Een gesprek starten met het actieve profiel",
  "Start a session and reply as this profile": "Een sessie starten en antwoorden als dit profiel",
  "Start Session": "Sessie starten",
  "Starting checkout…": "Betaalpagina wordt gestart…",
  "Starting…": "Wordt gestart…",
  "Stop the current session before starting a new one": "Stop de huidige sessie voordat je een nieuwe start",
  "Submit report": "Melding indienen",
  "Submitting…": "Wordt ingediend…",
  "this user": "deze gebruiker",
  "Top up to start a video call": "Waardeer op om een video-oproep te starten",
  "Top up to start a voice call": "Waardeer op om een spraakoproep te starten",
  "Type a message…": "Typ een bericht…",
  "Type your message…": "Typ je bericht…",
  "Unblock user": "Gebruiker deblokkeren",
  "Unknown": "Onbekend",
  "Unknown follower": "Onbekende volger",
  "Unmute notification sounds": "Meldingsgeluiden inschakelen",
  "Unmute notifications": "Meldingen inschakelen",
  "Upload failed": "Upload mislukt",
  "Use my current position": "Mijn huidige positie gebruiken",
  "user": "gebruiker",
  "User": "Gebruiker",
  "User avatar": "Gebruikersavatar",
  "Video call": "Video-oproep",
  "View photos": "Foto’s bekijken",
  "Voice call": "Spraakoproep",
  "Wait for uploads to finish": "Wacht tot de uploads zijn voltooid",
  "Waiting for video…": "Wachten op video…",
  "Waiting for voice…": "Wachten op spraak…",
  "You are in room": "Je bent in de room",
  "You are not in room": "Je bent niet in de room",
  "You:": "Jij:",
  "Your conversations": "Jouw gesprekken",
  "⏹ Stop Camera": "⏹ Camera stoppen",
  "■ End Session": "■ Sessie beëindigen",
  "▶ Enter Session": "▶ Deelnemen aan sessie",
  "✕ Decline": "✕ Afwijzen",
  "🌫️ Soft Blur": "🌫️ Lichte vervaging",
  "🌫️ Switch to Soft Blur": "🌫️ Overschakelen naar lichte vervaging",
  "🎙 Voice call": "🎙 Spraakoproep",
  "🎙 Voice session": "🎙 Spraaksessie",
  "👁 Face visible to the customer": "👁 Gezicht zichtbaar voor de klant",
  "👁 Reveal Face": "👁 Gezicht tonen",
  "📹 Video call": "📹 Video-oproep",
  "📹 Video session": "📹 Videosessie",
  "🕶️ Back to Incognito Blur": "🕶️ Terug naar incognitovervaging",
  "🕶️ Blur Again": "🕶️ Opnieuw vervagen",
  "🕶️ Incognito Blur": "🕶️ Incognitovervaging",
  "🚫 Calls from this customer are blocked": "🚫 Oproepen van deze klant zijn geblokkeerd",
  "Historical notes": "Historische notities",
  "From the old Tippelstraat system. Read-only, cannot be edited.": "Uit het oude Tippelstraat-systeem. Alleen-lezen, niet te bewerken.",
  "Loading historical notes…": "Historische notities laden…",
  "Date not recorded in the old system": "Datum niet vastgelegd in het oude systeem",
  "Profile unknown": "Profiel onbekend",
  "Conversations before 13 October 2026": "Gesprekken vóór 13 oktober 2026",
  "Loading earlier history…": "Eerdere geschiedenis laden…",
  "Earlier history could not be loaded.": "Eerdere geschiedenis kon niet worden geladen.",
  "Image no longer available": "Afbeelding niet meer beschikbaar",
  "History only": "Alleen historie",
  "From the old system, read-only": "Uit het oude systeem, alleen-lezen",
  "This conversation cannot be replied to. Start a new conversation to contact this customer.": "Op dit gesprek kan niet worden geantwoord. Start een nieuw gesprek om contact op te nemen met deze klant.",
  "Display": "Weergave",
  "System": "Systeem",
  "Light": "Licht",
  "Dark": "Donker",
  "Free office chat": "Gratis bureauchat",
  "Not following": "Volgt niet",
  "Office chat with": "Bureauchat met",
  "Agency": "Bureau",
  "Free office chat: you reply as the agency": "Gratis bureauchat: je antwoordt namens het bureau",
  "Free office chat: you reply as the agency. The customer is never charged.": "Gratis bureauchat: je antwoordt namens het bureau. De klant betaalt nooit.",
  "This customer does not follow the agency. You can reply again after the customer sends a new message or follows the agency.": "Deze klant volgt het bureau niet. Je kunt weer antwoorden zodra de klant een nieuw bericht stuurt of het bureau volgt.",
  "Replies are paused until the customer follows the agency": "Antwoorden staan stil tot de klant het bureau volgt",
  "Free chat with the agency": "Gratis chat met het bureau",
  "Guest via :source": "Gast via :source",
  "Guest": "Gast",
  "Registered": "Geregistreerd",
  "Registered after a guest chat via :source": "Geregistreerd na een gastchat via :source",
  "Registered after a guest chat": "Geregistreerd na een gastchat",
  "Anonymous guest, not registered": "Anonieme gast, niet geregistreerd",
  "Information chat": "Informatie chat",
  "Information chat: :status": "Informatie chat: :status",
  "Information chat: :open of :total open": "Informatie chat: :open van :total open",
  "Open until :time": "Open tot :time",
  "Open": "Open",
  "Closed, opens :time": "Gesloten, opent :time",
  "Closed": "Gesloten",
  "Closes in :duration": "Sluit over :duration",
  "Opens in :duration": "Opent over :duration",
  "Manual until :time": "Handmatig tot :time",
  "Manual": "Handmatig",
  "less than a minute": "minder dan een minuut",
  ":minutes min": ":minutes min",
  ":hours h": ":hours u",
  ":hours h :minutes min": ":hours u :minutes min",
  "Automatic (opening hours)": "Automatisch (openingstijden)",
  "Open now": "Nu openen",
  "Close now": "Nu sluiten",
  "A manual choice lasts until the next scheduled change.": "Een handmatige keuze geldt tot de volgende geplande wijziging.",
  "The information chat could not be switched. Please try again.": "De informatie chat kon niet worden omgezet. Probeer het opnieuw.",
  "Always open": "Altijd open",
  "Closed until midnight": "Gesloten tot middernacht",
  "You may not change the information chat of this office.": "Je mag de informatie chat van dit bureau niet wijzigen.",
  "Suggest ladies": "Stel dames voor",
  "Suggested ladies:": "Voorgestelde dames:",
  "These ladies are available now": "Deze dames zijn nu beschikbaar",
  "Choose up to :max ladies": "Kies maximaal :max dames",
  ":count of :max selected": ":count van :max gekozen",
  "Loading team…": "Team laden…",
  "No ladies in this team yet.": "Nog geen dames in dit team.",
  "The team could not be loaded.": "Het team kon niet worden geladen.",
  "Add to message": "Toevoegen aan bericht",
  "Remove :name": ":name verwijderen",
  "Online now at :office": "Nu online bij :office",
  "Online now: :names": "Nu online: :names",
  "Sent automatically as a welcome": "Automatisch verstuurd als welkomstbericht",
  "Contact :name": "Contact :name",
  "Hi :name 😉 :office recommended you. Are you available today?": "Hoi :name 😉 :office raadde jou aan. Ben je vandaag beschikbaar?",
  "Hi :name 😉 Are you available today?": "Hoi :name 😉 Ben je vandaag beschikbaar?",
  "Customer contacted :name": "Klant heeft contact opgenomen met :name",
  "Customer contacted a lady": "Klant heeft contact opgenomen met een dame",
  "This conversation is not in your queue.": "Dit gesprek staat niet in jouw wachtrij.",
  "Search by name": "Zoek op naam",
  "Search by place": "Zoek op plaats",
  "No places found": "Geen plaatsen gevonden",
  "Near :place": "In de buurt van :place",
  "Remove place :place": "Plaats :place verwijderen",
  ":km km": ":km km",
  "No ladies found": "Geen dames gevonden",
  "Open messages": "Open berichten",
  "No customers are waiting for an answer.": "Er wachten geen klanten op een antwoord.",
  "For :name": "Voor :name",
  "Assigned profile": "Toegewezen profiel",
  "Waiting time": "Wachttijd",
  "Show every conversation waiting for an answer": "Toon alle gesprekken die op een antwoord wachten",
  "Earlier chats": "Eerdere chats",
  "Your conversations from our previous website, read-only.": "Je gesprekken van onze vorige website, alleen-lezen.",
  ":count messages": ":count berichten",
  "Unknown profile": "Onbekend profiel",
  "Earlier chat with :name": "Eerdere chat met :name",
  "Load older messages": "Oudere berichten laden",
  "Loading chat history": "Chatgeschiedenis laden",
  "Chat history could not be loaded.": "De chatgeschiedenis kon niet worden geladen.",
  "This is an earlier conversation and cannot be replied to.": "Dit is een eerder gesprek, je kunt hier niet op reageren.",
  "Open current chat": "Huidige chat openen",
  "Attachment no longer available": "Bijlage niet meer beschikbaar",
  // TPS-392: chat content library ("Bibliotheek") and large chat videos.
  "Library": "Bibliotheek",
  "Upload": "Uploaden",
  "Remove": "Verwijderen",
  "Title": "Titel",
  "Preview": "Voorbeeld",
  "Load more": "Meer laden",
  "Note (only visible to the team)": "Notitie (alleen zichtbaar voor het team)",
  "The library is empty. Photos and videos you send in chats are added automatically.": "De bibliotheek is leeg. Foto's en video's die je in chats verstuurt, worden automatisch toegevoegd.",
  "Remove this item from the library? Messages that already contain it keep working.": "Dit item uit de bibliotheek verwijderen? Berichten waarin het al is verstuurd, blijven werken.",
  "This file is too large.": "Dit bestand is te groot.",
  "This file type is not supported in chat.": "Dit bestandstype wordt niet ondersteund in de chat.",
  "File is too large for chat (max :size MB).": "Bestand is te groot voor de chat (max. :size MB).",
  "The upload took too long and expired. Please start again.": "Het uploaden duurde te lang en is verlopen. Begin opnieuw.",
  "The upload could not be found. Please start again.": "De upload is niet gevonden. Begin opnieuw.",
  "Part of the upload was damaged. Please try again.": "Een deel van de upload is beschadigd. Probeer het opnieuw.",
  "Part of the upload is missing. Please try again.": "Een deel van de upload ontbreekt. Probeer het opnieuw.",
  "Processing the upload failed. Please try again.": "Het verwerken van de upload is mislukt. Probeer het opnieuw.",
  "Processing the upload takes too long. Please try again later.": "Het verwerken van de upload duurt te lang. Probeer het later opnieuw.",
  "Uploading is temporarily unavailable. Please try again later.": "Uploaden is tijdelijk niet mogelijk. Probeer het later opnieuw.",
  "You do not have access to this library.": "Je hebt geen toegang tot deze bibliotheek.",
  "This chat has no profile library.": "Deze chat heeft geen profielbibliotheek.",
  "This item no longer exists.": "Dit item bestaat niet meer.",
  "Too many uploads. Please wait a moment.": "Te veel uploads. Wacht even.",
  "The connection was interrupted. Please check your connection and try again.": "De verbinding is onderbroken. Controleer je verbinding en probeer het opnieuw.",
};
